module.exports = __webpack_public_path__ + "static/media/Courier.f6747bfe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/iLocal-Delivery-Icons/Courier.svg
// module id = 1949
// module chunks = 0